import { api } from "../lib/api";

export const account = () =>
  api
    .get("/mail/account")
    .then((response) => response.data);

export const configureAccount = (payload) =>
  api
    .put("/mail/account", {
      password: payload?.password || "",
    })
    .then((response) => response.data);

export const testAccount = () =>
  api
    .post("/mail/account/test")
    .then((response) => response.data);

export const getSignature = () =>
  api
    .get("/mail/signature")
    .then((response) => response.data);

export const saveSignature = (
  text,
  autoEnabled = false
) =>
  api
    .put(
      "/mail/signature",
      {
        text,
        auto_enabled: autoEnabled,
      }
    )
    .then((response) => response.data);

export const sync = () =>
  api
    .post("/mail/sync")
    .then((response) => response.data);

export const listMessages = ({
  folder = "inbox",
  folderId = "",
  page = 1,
  limit = 30,
  search = "",
} = {}) =>
  api
    .get("/mail/messages", {
      params: {
        folder,
        folder_id: folderId,
        page,
        limit,
        search,
      },
    })
    .then((response) => response.data);

export const listDrafts = ({
  page = 1,
  limit = 30,
  search = "",
} = {}) =>
  api
    .get("/mail/drafts", {
      params: {
        page,
        limit,
        search,
      },
    })
    .then((response) => response.data);

export const saveDraft = (payload) =>
  api
    .post(
      "/mail/drafts",
      payload
    )
    .then((response) => response.data);

export const updateDraft = (
  id,
  payload
) =>
  api
    .patch(
      `/mail/drafts/${encodeURIComponent(id)}`,
      payload
    )
    .then((response) => response.data);

export const deleteDraft = (id) =>
  api
    .delete(
      `/mail/drafts/${encodeURIComponent(id)}`
    )
    .then((response) => response.data);

export const getMessage = (id) =>
  api
    .get(
      `/mail/messages/${encodeURIComponent(id)}`
    )
    .then((response) => response.data);

export const updateMessage = (
  id,
  payload
) =>
  api
    .patch(
      `/mail/messages/${encodeURIComponent(id)}`,
      payload
    )
    .then((response) => response.data);

export const associateContact = (
  id,
  email
) =>
  api
    .post(
      `/mail/messages/${encodeURIComponent(id)}/contact`,
      {
        email,
      }
    )
    .then((response) => response.data);

export const affairSuggestions = (
  search
) =>
  api
    .get(
      "/mail/affair-suggestions",
      {
        params: {
          search,
          limit: 10,
        },
      }
    )
    .then((response) => response.data);

export const associateAffair = (
  id,
  opportunityId
) =>
  api
    .post(
      `/mail/messages/${encodeURIComponent(id)}/affair`,
      {
        opportunity_id: opportunityId,
      }
    )
    .then((response) => response.data);

export const machineSuggestions = (
  search
) =>
  api
    .get(
      "/mail/machine-suggestions",
      {
        params: {
          search,
          limit: 10,
        },
      }
    )
    .then((response) => response.data);

export const associateMachine = (
  id,
  machineId
) =>
  api
    .post(
      `/mail/messages/${encodeURIComponent(id)}/machine`,
      {
        machine_id: machineId,
      }
    )
    .then((response) => response.data);

export const installationSuggestions = (
  search
) =>
  api
    .get(
      "/mail/installation-suggestions",
      {
        params: {
          search,
          limit: 10,
        },
      }
    )
    .then((response) => response.data);

export const associateInstallation = (
  id,
  installationId
) =>
  api
    .post(
      `/mail/messages/${encodeURIComponent(id)}/installation`,
      {
        installation_id: installationId,
      }
    )
    .then((response) => response.data);

export const interventionSuggestions = (
  search
) =>
  api
    .get(
      "/mail/intervention-suggestions",
      {
        params: {
          search,
          limit: 10,
        },
      }
    )
    .then((response) => response.data);

export const associateIntervention = (
  id,
  interventionId
) =>
  api
    .post(
      `/mail/messages/${encodeURIComponent(id)}/intervention`,
      {
        intervention_id: interventionId,
      }
    )
    .then((response) => response.data);

export const trashMessage = (id) =>
  api
    .delete(
      `/mail/messages/${encodeURIComponent(id)}`
    )
    .then((response) => response.data);

export const send = (formData) =>
  api
    .post(
      "/mail/send",
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    )
    .then((response) => response.data);

export const schedule = (formData) =>
  api
    .post(
      "/mail/scheduled",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => response.data);

export const listScheduled = () =>
  api
    .get("/mail/scheduled")
    .then((response) => response.data);

export const getScheduled = (id) =>
  api
    .get(`/mail/scheduled/${encodeURIComponent(id)}`)
    .then((response) => response.data);

export const updateScheduled = (id, formData) =>
  api
    .patch(
      `/mail/scheduled/${encodeURIComponent(id)}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    )
    .then((response) => response.data);

export const cancelScheduled = (id, revision) =>
  api
    .delete(
      `/mail/scheduled/${encodeURIComponent(id)}`,
      { params: { expected_revision: revision } }
    )
    .then((response) => response.data);

export const addressBook = ({
  search = "",
  page = 1,
  limit = 50,
} = {}) =>
  api
    .get(
      "/mail/address-book",
      {
        params: {
          search,
          page,
          limit,
        },
      }
    )
    .then((response) => response.data);


export const recipientSuggestions = (
  search
) =>
  api
    .get(
      "/mail/recipient-suggestions",
      {
        params: {
          search,
          limit: 10,
        },
      }
    )
    .then((response) => response.data);


export const contactCandidate = (
  email
) =>
  api
    .get(
      "/mail/contact-candidate",
      {
        params: {
          email,
        },
      }
    )
    .then((response) => response.data);

export const saveContactPrompt = (
  email,
  decision
) =>
  api
    .post(
      "/mail/contact-prompt",
      {
        email,
        decision,
      }
    )
    .then((response) => response.data);

export const relinkContact = (
  email
) =>
  api
    .post(
      "/mail/relink-contact",
      {
        email,
      }
    )
    .then((response) => response.data);

export const adminAccount = (userId) =>
  api
    .get(
      `/mail/admin/users/${encodeURIComponent(userId)}/account`
    )
    .then((response) => response.data);

export const adminConfigureAccount = (
  userId,
  payload
) =>
  api
    .put(
      `/mail/admin/users/${encodeURIComponent(userId)}/account`,
      {
        email: payload.email,
        imap_host: payload.imap_host,
        imap_port: payload.imap_port,
        smtp_host: payload.smtp_host,
        smtp_port: payload.smtp_port,
      }
    )
    .then((response) => response.data);

export const adminTestAccount = (userId) =>
  api
    .post(
      `/mail/admin/users/${encodeURIComponent(userId)}/account/test`
    )
    .then((response) => response.data);

export const moveMessage = (
  id,
  folder,
  folderId = ""
) =>
  api
    .post(
      `/mail/messages/${encodeURIComponent(id)}/move`,
      {
        folder,
        folder_id: folderId,
      }
    )
    .then((response) => response.data);

export const listRules = () =>
  api
    .get("/mail/rules")
    .then((response) => response.data);

export const createRule = (payload) =>
  api
    .post(
      "/mail/rules",
      payload
    )
    .then((response) => response.data);

export const updateRule = (
  id,
  payload
) =>
  api
    .patch(
      `/mail/rules/${encodeURIComponent(id)}`,
      payload
    )
    .then((response) => response.data);

export const deleteRule = (id) =>
  api
    .delete(
      `/mail/rules/${encodeURIComponent(id)}`
    )
    .then((response) => response.data);

export const listFolders = () =>
  api
    .get("/mail/folders")
    .then((response) => response.data);

export const createFolder = (name) =>
  api
    .post(
      "/mail/folders",
      {
        name,
      }
    )
    .then((response) => response.data);

export const renameFolder = (
  id,
  name
) =>
  api
    .patch(
      `/mail/folders/${encodeURIComponent(id)}`,
      {
        name,
      }
    )
    .then((response) => response.data);

export const deleteFolder = (id) =>
  api
    .delete(
      `/mail/folders/${encodeURIComponent(id)}`
    )
    .then((response) => response.data);

export const deleteMessagePermanently = (
  id
) =>
  api
    .delete(
      `/mail/messages/${encodeURIComponent(id)}/permanent`
    )
    .then((response) => response.data);
